import React from 'react';

const pctOf = (num, den) => (den > 0 ? Math.round((num / den) * 100) : 0);

function FunnelBar({ label, count, ofCount, colorClass }) {
  const width = ofCount > 0 ? Math.max(count > 0 ? 4 : 0, Math.round((count / ofCount) * 100)) : 0;
  return (
    <div>
      <div className="flex items-baseline justify-between text-sm mb-1">
        <span className="text-gray-600">{label}</span>
        <span className="font-semibold text-gray-900">{count}</span>
      </div>
      <div className="h-2 bg-gray-100 rounded-full overflow-hidden">
        <div className={`h-full ${colorClass} rounded-full`} style={{ width: `${width}%` }} />
      </div>
    </div>
  );
}

// Renders the click_funnel shape returned by getAffiliateClickFunnel()
// (admin-affiliates.js) — shared by the affiliate's own dashboard
// (AffiliateDashboardView.jsx) and the admin per-affiliate detail
// (AffiliatesAdmin.jsx) so the two never hand-roll two different renderings
// of the same numbers. Plain Tailwind, no charting library — this is reporting
// on what's still near-zero real traffic, so legibility first.
export default function AffiliateClickFunnel({ data }) {
  if (!data) return null;
  const { totals, by_channel } = data;

  if (totals.clicks === 0) {
    return (
      <div className="bg-white rounded-lg border border-gray-200 p-6">
        <h3 className="font-semibold text-gray-900 mb-1">Click funnel</h3>
        <p className="text-sm text-gray-400">No clicks logged yet. Once someone follows the referral link, clicked → started checkout → converted shows up here.</p>
      </div>
    );
  }

  const hasChannelData = by_channel.some((c) => c.channel);

  return (
    <div className="bg-white rounded-lg border border-gray-200 p-6 space-y-6">
      <div>
        <h3 className="font-semibold text-gray-900 mb-4">Click funnel</h3>
        <div className="space-y-3">
          <FunnelBar label="Clicks" count={totals.clicks} ofCount={totals.clicks} colorClass="bg-indigo-500" />
          <FunnelBar
            label={`Started checkout (${pctOf(totals.checkout_started, totals.clicks)}% of clicks)`}
            count={totals.checkout_started}
            ofCount={totals.clicks}
            colorClass="bg-indigo-400"
          />
          <FunnelBar
            label={`Converted (${pctOf(totals.converted, totals.clicks)}% of clicks)`}
            count={totals.converted}
            ofCount={totals.clicks}
            colorClass="bg-green-500"
          />
        </div>
      </div>

      {hasChannelData && (
        <div>
          <h4 className="text-sm font-semibold text-gray-900 mb-2">By link tag (&src=)</h4>
          <table className="w-full text-sm">
            <thead>
              <tr className="text-left text-gray-500 border-b">
                <th className="py-2">Tag</th><th>Clicks</th><th>Started</th><th>Converted</th><th>Conv. rate</th>
              </tr>
            </thead>
            <tbody>
              {by_channel.map((c) => (
                <tr key={c.channel || '(none)'} className="border-b last:border-0">
                  <td className="py-2 font-mono text-xs">{c.channel || <span className="text-gray-400 italic font-sans">no tag</span>}</td>
                  <td>{c.clicks}</td>
                  <td>{c.checkout_started}</td>
                  <td>{c.converted}</td>
                  <td>{pctOf(c.converted, c.clicks)}%</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
